module.exports = __webpack_public_path__ + "img/maschine-default.05627aa7.png";